import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-forest relative overflow-hidden" data-id="element-259">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-260"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-261">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-262">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/10 text-gold mb-5" data-id="element-263">
            <span className="text-2xl" data-id="element-264">🏆</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 text-cream" data-id="element-265">
            El sistema más completo de producción agropecuaria para el aula de
            habla hispana.
          </h2>
          <h3 className="text-xl font-bold text-gold-gradient mb-3" data-id="element-266">
            Mega Pack Producción Agropecuaria 360°
          </h3>
          <p className="text-base md:text-lg text-cream-dark mb-10" data-id="element-267">
            5 tomos · 4 bonos estratégicos · Todo listo para usar desde hoy.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-268">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-3 bg-forest-dark p-6 rounded-2xl border border-forest-light" data-id="element-269">
            <div className="flex items-start gap-3" data-id="element-270">
              <X className="text-red-400 shrink-0 mt-1" size={18} data-id="element-271" />
              <p className="text-cream-dark text-sm" data-id="element-272">
                No es teoría copiada de un manual universitario.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-273">
              <X className="text-red-400 shrink-0 mt-1" size={18} data-id="element-274" />
              <p className="text-cream-dark text-sm" data-id="element-275">
                No es una colección de actividades sueltas sin contexto.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-276">
              <X className="text-red-400 shrink-0 mt-1" size={18} data-id="element-277" />
              <p className="text-cream-dark text-sm" data-id="element-278">
                No es material que tengas que adaptar entero antes de usarlo.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gold/10 p-6 rounded-2xl border border-gold/30 relative overflow-hidden" data-id="element-279">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/20 blur-3xl rounded-full" data-id="element-280"></div>
            <div className="flex items-start gap-3 relative z-10" data-id="element-281">
              <Check className="text-gold shrink-0 mt-1" size={20} data-id="element-282" />
              <p className="text-cream font-medium text-base leading-relaxed" data-id="element-283">
                Es un sistema para que entres al aula con confianza y dictes
                clases que de verdad enseñen a producir.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}